export const orderResetMiddleware = () => (next) => (currentAction) => {
  let action = {...currentAction};

  if (action.type === 'order/resetOrder') {
    if (localStorage.getItem('isFromCheckoutPage') && window['orderPageLoadConfig'] && Object.keys(window['orderPageLoadConfig']).length) {
      action = {
        ...action,
        payload: false
      }
    } else {
      action = {
        ...action,
        payload: true
      }
    }
  }
  next(action);
}
